import customerProfileSaga from './customerProfileSaga';
import changeContactSaga from './changeContactSaga';
import customerResetUserNameSaga from './customerResetUserNameSaga';
import customerResetPasswordSaga from './customerResetPasswordSaga';
import customerProfileVerifySaga from './customerProfileVerifySaga';
import changeEmailSaga from './changeEmailSaga';
import changeMobileSaga from './changeMobileSaga';
import insuredAccessSaga from './insuredAccessSaga';
import modalSaga from './modalSaga';
import changeAddressSaga from './changeAddressSaga';

export default [
  customerProfileSaga,
  changeContactSaga,
  changeAddressSaga,
  changeEmailSaga,
  changeMobileSaga,
  customerResetUserNameSaga,
  customerResetPasswordSaga,
  customerProfileVerifySaga,
  insuredAccessSaga,
  modalSaga,
];
